import React, { useState } from 'react';
import { Container, Grid, Card, Icon, Image, Menu, Button, Dimmer, Loader, Label } from 'semantic-ui-react';
import styled from 'styled-components';
import './App.css';
import axios from 'axios';
import { useAuth0 } from "@auth0/auth0-react";

import Leads from './Leads';
import Welcome from './Welcome';
import LoginButton from './LoginButton';
import LogoutButton from './LogoutButton';
import leadsData from './leads.json';

const leads = JSON.parse(localStorage.getItem('leads')) || leadsData;

function App(props) {
  const [loading, setLoading] = useState(false);
  const { user, isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();

  return (
    <div className={props.className}>
      <Dimmer active={loading || isLoading}>
        <Loader>Please Wait...</Loader>
      </Dimmer>
      <div>
        <Menu fixed="top" id="nav">
          <Container>
            <Menu.Item header position='left'>
              <Image
                size="mini"
                src="/ae-logo.png" // Replace with your logo path
                style={{ height: '50px', width: '200px' }}
              />
            </Menu.Item>
            <Menu.Menu position='right'>
              <Menu.Item>
                <Icon name="user circle" size="big" /> { isAuthenticated ? user.name : 'Guest' }
              </Menu.Item>
              <Menu.Item>
                { isAuthenticated ? <LogoutButton /> : <LoginButton /> }
              </Menu.Item>
            </Menu.Menu>
          </Container>
        </Menu>
        
        
        { isAuthenticated ? ( <Leads 
          leads={leads} 
          setLoading={setLoading} 
          getAccessTokenSilently={getAccessTokenSilently} 
          user={user}
          />) : <Welcome /> }
      </div>
    </div>
  );
}

export default styled(App)`
  background: #f2f2f2;
  
  .dimmer {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
  }

  #nav {
    .button {
      background: white !important;     
    }

    .header {
      border: none !important;
      border-right: none !important;
    }

    .header::before {
      display: none !important;
    }
  }
`;
